import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import Popover from 'react-tiny-popover';
import { Box, Grid, Typography, Button, useTheme, useMediaQuery, Paper } from '@material-ui/core';
import ShortOrderList from '../../components/ProfileOrder/ShortOrderList';
import { PersonalLoc } from '../../loc/personal';
import { loc } from '../../lib/loc';
import PageSubTitle from '../../components/UI/PageSubTitle';
import DiscountCard from '../../components/Cards/DiscountCard';
import NextLevelPoints from '../../components/Cards/NextLevelPoints';
import Points from '../../components/Cards/Points';
import { useStores } from '../../hooks/use-stores';
import Loader from '../../components/Loader';

const PersonalArea = observer(() => {
    const { LoyaltyStore: store } = useStores();

    // Effects
    useEffect(() => {
        store.getLevels();
    }, [store]);

    const theme = useTheme();
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <Box mb={7}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={4}>
                        <DiscountCard title="Cкидка на вакуумное оборудование" type="current" withRequest withBottomPadding />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Points
                            bottomBtn={
                                <Link
                                    to={{
                                        pathname: '/loyalty',
                                        hash: '#faq',
                                        state: { activeTabID: 1 },
                                    }}
                                >
                                    Потратить
                                </Link>
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <NextLevelPoints
                            bottomBtn={
                                <Link
                                    to={{
                                        pathname: '/loyalty',
                                        hash: '#faq',
                                        state: { activeTabID: 0 },
                                    }}
                                >
                                    Накопить
                                </Link>
                            }
                        />
                    </Grid>
                </Grid>
            </Box>

            <PageSubTitle>Бонусная программа</PageSubTitle>
            <Box mb={7.5}>
                {store.loading && <Loader />}
                {!store.loading && !!store.levels?.length ? (
                    <div className="privilege">
                        <div className="privilege__col">
                            <div className="privilege-type">
                                <div className="privilege-type__icon">
                                    <img src={store.userLevelInfo?.image_available} alt="" className="sprite-icon" />
                                </div>
                                <div className="privilege-type__text">
                                    <div className="privilege-type__title">{store.userLevelInfo?.name}</div>
                                    <div className="privilege-type__desc">{store.userLevelInfo?.points} баллов</div>
                                </div>
                            </div>
                        </div>
                        <div className="privilege__col">
                            <div className="privilege__desc">
                                <Box mb={3}>
                                    <Typography>
                                        {store.userLevelInfo?.level_description} <Link to="/loyalty">Детальнее</Link>
                                    </Typography>
                                </Box>

                                <Grid container spacing={1} justify={isSM ? 'center' : 'flex-start'}>
                                    <Grid item>
                                        <LoyaltyInfoItemButton title="О программе">
                                            В программе предусмотрено 16 уровней, которые зависят от количества накопленных баллов. На
                                            каждом уровне помимо возможности тратить накопленные баллы, предусмотрены дополнительные
                                            привилегии. Независимо от потраченных баллов ваш уровень не сгорает.
                                        </LoyaltyInfoItemButton>
                                    </Grid>
                                    <Grid item>
                                        <LoyaltyInfoItemButton title="Как я могу участвовать?">
                                            Для того, чтобы стать участником программы лояльности необходимо взять в аренду, воспользоваться
                                            услугами сервиса или приобрести технику Арлифт.
                                        </LoyaltyInfoItemButton>
                                    </Grid>
                                    <Grid item>
                                        <LoyaltyInfoItemButton title="Какие привилегии я получу?">
                                            В зависимости от уровня в программе лояльности предусмотрены приятные бонусы: от персонального
                                            специалиста технической поддержки до участия в закрытых мероприятиях.
                                        </LoyaltyInfoItemButton>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>
                ) : null}
            </Box>

            <PageSubTitle>{loc(PersonalLoc.personal.lastOrders)}</PageSubTitle>
            <ShortOrderList />
            <div className="text-center mb-60">
                <Link className="custom-btn" to="/orders/">
                    {loc(PersonalLoc.personal.allOrdersButton)}
                </Link>
            </div>
        </>
    );
});

const LoyaltyInfoItemButton = ({ title, children }) => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    return (
        <Popover
            isOpen={isPopoverOpen}
            position={['bottom', 'center']}
            padding={10}
            disableReposition
            onClickOutside={() => setIsPopoverOpen(false)}
            content={() => (
                <Box width={500}>
                    <Paper>
                        <Box p={3}>{children}</Box>
                    </Paper>
                </Box>
            )}
        >
            <Button
                variant="outlined"
                color="primary"
                size="small"
                onMouseEnter={() => setIsPopoverOpen(true)}
                onMouseLeave={() => setIsPopoverOpen(false)}
            >
                {title}
            </Button>
        </Popover>
    );
};

export default PersonalArea;
